import * as React from 'react';
import * as Redux from 'react-redux';
import { allPeriodosAcademicosAction } from '../PeriodosAcademicosAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';

const SelectFieldPeriodosAcademicosComponent = ({
  onChange,
  data,
  value,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const periodosAcademicosStore = Redux.useSelector(
    (state) => state.periodosAcademicos,
  );

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && periodosAcademicosStore.all.length === 0) {
        await allPeriodosAcademicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setItems(periodosAcademicosStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      periodosAcademicosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(periodosAcademicosStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.periodoAcademico.name}`}>
        {CONST.periodoAcademico.label}
      </InputLabel>
      <Select
        id={CONST.periodoAcademico.name}
        value={value}
        labelId={`label_${CONST.periodoAcademico.name}`}
        label={CONST.periodoAcademico.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {items.map((el, index) => {
          return (
            <MenuItem key={`periodoAcademico-${index}`} value={el.id}>
              {el.nombre} ({el.desde}-{el.hasta})
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-items"
      opt={items}
      type={CONST.periodoAcademico.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l={CONST.periodoAcademico.label}
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldPeriodosAcademicosComponent;
